import { ConectoresNotificacao, ConectoresNotificacaoCadastro } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/notificacao',
    parent: '/conectores',
    text: 'Notificações',
    component: ConectoresNotificacao,
    secret: true,
    sider: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/notificacao/email/:id',
    parent: '/conectores/notificacao',
    component: ConectoresNotificacaoCadastro,
    secret: true,
    sider: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
